import { Entity, MicroMClient } from "@mcurros2/microm";
import { PersonalTiendasFiltersPorPersonalDef } from "./PersonalTiendasFiltersPorPersonalDef";

export class PersonalTiendasFiltersPorPersonal extends Entity<PersonalTiendasFiltersPorPersonalDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalTiendasFiltersPorPersonalDef(), parentKeys);
        this.Form = import('./PersonalTiendasFiltersPorPersonalForm').then((module) => module.PersonalTiendasFiltersPorPersonalForm);
        this.Title = "Personal Tiendas Filters por Personal";
    }
}